import axios from 'axios'

// Для Vue CLI (webpack) используем process.env.VUE_APP_* или process.env.VITE_*.
const BASE =
  (typeof process !== 'undefined' && process.env && (process.env.VUE_APP_API_BASE || process.env.VITE_API_BASE))
    || '/api/v1'

const api = axios.create({
  baseURL: BASE,
  timeout: 15000,
  headers: { Accept: 'application/json' }
})

api.interceptors.response.use(
  res => res.data,
  err => Promise.reject(err?.response?.data || err)
)

export default api